/**
 * Ajax addtocart Btn
 * ======================================
 * - jquery needed
 * - handled with ajax/index.php
 */
import $ from "jquery";
import { debounce } from "../utils/debounce";

const $cart_count = $("#woo-cart_count");
const $cart_total = $("#woo-cart_total");
const $emptycart = $("#woocommerce-emptycart");
const $list = $(".woo-basket__list");

$("body").on("click", ".js-addtocart", function(e) {
	const $btn = $(this);
	const product_id = $btn.attr("data-product_id");

	var data = new FormData();
	data.append("action", "addtocart");
	data.append("product", product_id);

	// same product is in cart?
	const $equalrow = $list.find('[data-product="' + product_id + '"]');

	$btn.addClass("added");
	setTimeout(() => {
		$btn.removeClass("added").addClass("removing");
	}, 1000);

	setTimeout(() => {
		$btn.removeClass("removing");
	}, 1300);

	if ($equalrow.length > 0) {
		$equalrow.find(".number-input input").val(function(i, oldval) {
			var suffix = $equalrow.find(".number-input input").data("suffix");
			var oldval = oldval.replace(' ' + suffix, "");

			var newVal = ++oldval + ' ' + suffix;

			return newVal;
		});

		$equalrow.find(".number-input input").trigger("input");
	} else {
		// ajax js
		const xhr = new XMLHttpRequest();
		xhr.open("POST", ajaxUrl + "/index.php", true);
		$btn.addClass("disabled");
		xhr.send(data);

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				// success
				if (xhr.status === 200) {
					$btn.removeClass("disabled");
					const response = JSON.parse(xhr.response);

					$list.append(response.item_html);

					var event = new Event("ajax-addtocart");
					window.dispatchEvent(event);

					$cart_count.html(response.cart_count);
					$cart_total.html(response.cart_total);

					var event = new Event("ajax-popcart");
					window.dispatchEvent(event);

					if (response.cart_count == 0) {
						$emptycart.removeClass("is-hidden");
					} else {
						$emptycart.addClass("is-hidden");
					}
				}
				// error
				else {
					console.log("ajaxForm error!", xhr);
				}
			}
		};
	}

	e.preventDefault();
});

window.addEventListener("ajax-popcart", debounce(popCartCount));

function popCartCount() {
	$cart_count.addClass("updated");
	setTimeout(function() {
		$cart_count.removeClass("updated");
	}, 300);
}
